export default __webpack_public_path__ + "static/media/GameActive.56502968.svg";